import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './Preloader.scss';

const normalizeCssColor = (value) => {
  if (!value) return null;

  const color = String(value).trim();

  if (/^(#|rgb|hsl|var\()/i.test(color)) {
    return color;
  }

  if (/^\d+\s*,\s*\d+\s*,\s*\d+/.test(color)) {
    return `rgb(${color})`;
  }

  return color;
};

const setThemeColor = (name, colorData) => {
  const color = normalizeCssColor(colorData?.rgb || colorData);
  if (color) {
    document.documentElement.style.setProperty(name, color);
  }
};

const Preloader = (props) => {
  const { showPreloader,client } = props;
  useEffect(() => {
    document.body.style.overflow = (showPreloader) ? 'hidden' : 'auto';
  }, [showPreloader]);

  useEffect(()=>{
    if (client){
      setThemeColor('--color-base', client.color_prin);
      setThemeColor('--color-base-hover', client.color_sec);
      setThemeColor('--color-text', client.color_text);
      setThemeColor('--color-text-selected', client.color_text_selected);
      setThemeColor('--color-title', client.color_title);
      setThemeColor('--color-nav2', client.color_nav2);
      setThemeColor('--color-nav-text2', client.color_nav_text2);
      setThemeColor('--color-price', client.color_price_text);
      setThemeColor('--color-button', client.color_button);
      setThemeColor('--color-button-text', client.color_button_text);
      setThemeColor('--brand-footer-bg', client.color_footer_background);
      setThemeColor('--brand-footer-title', client.color_footer_title);
      setThemeColor('--brand-footer-text', client.color_footer_text);
      setThemeColor('--brand-footer-bottom-bg', client.color_footer_bottom);
    }
  },[client])

  return (
    <div className={`preloader ${(showPreloader) ? '' : 'hide'}`} data-testid="preloader">
      {showPreloader &&
        <div className="preloader-content-container">
          <div className="loader-dots-container">
            <div className="loader-dot dot-1" />
            <div className="loader-dot dot-2" />
            <div className="loader-dot dot-3" />
          </div>
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  showPreloader: state.app.showPreloader,
  client: state.app.client,
});

Preloader.propTypes = {
  showPreloader: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Preloader);
